import { motion } from 'framer-motion';
import { Heart, Shield, Users } from 'lucide-react';

const pillars = [
  {
    icon: Heart,
    title: 'Health',
    color: 'rose',
    features: ['Sleep tracking', 'Recovery insights', 'Heart rate monitoring'],
  },
  {
    icon: Shield,
    title: 'Safety',
    color: 'blue',
    features: ['Real-time GPS', 'Geofencing alerts', 'Emergency SOS'],
  },
  {
    icon: Users,
    title: 'Connection',
    color: 'emerald',
    features: ['Family dashboard', 'Group chat', 'Daily reports'],
  },
];

const colorClasses = {
  rose: { bg: 'bg-rose-50', icon: 'text-rose-600' },
  blue: { bg: 'bg-blue-50', icon: 'text-blue-600' },
  emerald: { bg: 'bg-emerald-50', icon: 'text-emerald-600' },
};

const ThreePillars = () => {
  return (
    <section className="section section-warm" data-testid="three-pillars-section">
      <div className="container-custom">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1A1A1A] mb-3">
            Three Pillars. One Band.
          </h2>
          <p className="text-[#5A5A5A] text-base md:text-lg max-w-lg mx-auto">
            Everything your family needs, nothing it doesn't.
          </p>
        </motion.div>

        {/* Pillars */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {pillars.map((pillar, index) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="wellness-card text-center"
              data-testid={`pillar-${pillar.title.toLowerCase()}`}
            >
              <div className={`w-14 h-14 mx-auto mb-5 rounded-2xl ${colorClasses[pillar.color].bg} 
                              flex items-center justify-center`}>
                <pillar.icon className={`w-7 h-7 ${colorClasses[pillar.color].icon}`} />
              </div>
              
              <h3 className="text-xl font-semibold text-[#1A1A1A] mb-4">
                {pillar.title}
              </h3>
              
              <ul className="space-y-2">
                {pillar.features.map((feature) => (
                  <li key={feature} className="text-[#5A5A5A] text-sm">
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreePillars;
